import { useContext } from 'react';

import { DrawerContext } from '@/contexts/drawerContext';

export const useDrawer = () => {
  const context = useContext(DrawerContext);
  if (!context) {
    throw new Error('useDrawer debe usarse dentro de DrawerProvider');
  }
  return context;
};
